import { Typography } from "@fullscript/aviary-web";
import { useTranslation } from "react-i18next";

import { l } from "@shared/locales/i18n";

import * as styles from "./OrSection.styles";

interface OrSectionProps {
  isFullWidth?: boolean;
}

const OrSection = ({ isFullWidth }: OrSectionProps) => {
  const { t } = useTranslation();

  return (
    <Typography
      variant="footnote"
      isMarginless
      customCss={isFullWidth ? styles.orSectionFullWidth : styles.orSection}
      intention="neutral"
      colorIntensity="subtle"
    >
      {t(l.magicLink.Or)}
    </Typography>
  );
};

export { OrSection };
